import { createReducer } from '@reduxjs/toolkit';
import {
  setOriginPath,
  lockBackwardNavigation,
  unlockBackwardNavigation,
  enableEditFlow,
  disableEditFlow,
  enableDIPToFullEditFlow,
  disableDIPToFullEditFlow,
  enableBackFlowFromFinalReview,
  disableBackFlowFromFinalReview,
  enableCancelFlowFromLoanScreen,
  disableCancelFlowFromLoanScreen,
  enableBackFlowFromContactDetails,
  disableBackFlowFromContactDetails,
  enableBackFlowFromMarketingPreferences,
  disableBackFlowFromMarketingPreferences,
  enableResumeBackFlowFromAboutThisCheck,
  disableResumeBackFlowFromAboutThisCheck
} from 'actionCreators/navigation';

const navigationReducer = createReducer(
  {
    originPath: null,
    allowBackwardNavigation: true,
    isEditFlow: false,
    isDipToFullEditFlow: false,
    isBackFlowFromFullEdit: false,
    hasCancelClicked: false,
    isBackFromContactDetails: false,
    isBackFromMarketingPreferences: false,
    isBackFromAboutThisCheckInResume: false
  },
  (builder) => {
    builder.addCase(setOriginPath, (state, action) => {
      state.originPath = action.payload;
    });

    builder.addCase(lockBackwardNavigation, (state) => {
      state.allowBackwardNavigation = false;
    });

    builder.addCase(unlockBackwardNavigation, (state) => {
      state.allowBackwardNavigation = true;
    });

    builder.addCase(enableEditFlow, (state) => {
      state.isEditFlow = true;
    });

    builder.addCase(disableEditFlow, (state) => {
      state.isEditFlow = false;
    });

    builder.addCase(enableDIPToFullEditFlow, (state) => {
      state.isDipToFullEditFlow = true;
    });

    builder.addCase(disableDIPToFullEditFlow, (state) => {
      state.isDipToFullEditFlow = false;
    });

    builder.addCase(enableBackFlowFromFinalReview, (state) => {
      state.isBackFlowFromFullEdit = true;
    });

    builder.addCase(disableBackFlowFromFinalReview, (state) => {
      state.isBackFlowFromFullEdit = false;
    });

    builder.addCase(enableCancelFlowFromLoanScreen, (state) => {
      state.hasCancelClicked = true;
    });

    builder.addCase(disableCancelFlowFromLoanScreen, (state) => {
      state.hasCancelClicked = false;
    });

    builder.addCase(enableBackFlowFromContactDetails, (state) => {
      state.isBackFromContactDetails = true;
    });

    builder.addCase(disableBackFlowFromContactDetails, (state) => {
      state.isBackFromContactDetails = false;
    });

    builder.addCase(enableBackFlowFromMarketingPreferences, (state) => {
      state.isBackFromMarketingPreferences = true;
    });

    builder.addCase(disableBackFlowFromMarketingPreferences, (state) => {
      state.isBackFromMarketingPreferences = false;
    });

    builder.addCase(enableResumeBackFlowFromAboutThisCheck, (state) => {
      state.isBackFromAboutThisCheckInResume = true;
    });

    builder.addCase(disableResumeBackFlowFromAboutThisCheck, (state) => {
      state.isBackFromAboutThisCheckInResume = false;
    });
  }
);

export { navigationReducer };
